export default __webpack_public_path__ + "static/media/post-12-detail.6958a1d0.jpg";